import { createContext } from "react";

export const SystemProfile = createContext()